<div *ngIf="user$ | async as user">
  <span
    class="sidebar_switch bs_ttip on_switch off_switch"
    *ngIf="isAdmin$ | async"
    (click)="show = !show"
    title="Sidebar"
    >Sidebar switch</span
  >
  <div
    *ngIf="isAdmin$ | async"
    class="sidebar ns"
    id="sidebar"
    [hidden]="!show"
  >
    <div
      class="slimScrollDiv"
      style="position: relative; overflow: hidden; width: auto; height: 500px"
    >
      <div
        class="sidebar_inner_scroll"
        style="overflow: hidden; width: auto; height: 500px"
      >
        <div
          class="sidebar_inner"
          style="margin-bottom: -92px; min-height: 100%"
        >
          <div id="side_accordion" class="panel-group" style="padding: 0px">
            <div
              *ngFor="let sidebar of routesSidebar$ | async; let i = index"
              class="panel"
              style="padding: 0px; padding-bottom: 10px; border: 0px !important"
            >
              <div
                class="panel-heading"
                *ngIf="sidebar.data.sidebar === 'group'"
                style="margin-bottom: 10px"
              >
                <div
                  style="cursor: pointer"
                  class="accordion-toggle collapsed"
                  (click)="isCollapsed[i] = !isCollapsed[i]"
                >
                  <i class="glyphicon {{ sidebar.data.icon }}"></i>
                  {{ sidebar.data.label }}
                </div>
              </div>
              <div id="{{ sidebar.data.id }}" [collapse]="isCollapsed[i]">
                <div *ngFor="let subpanel of routesSubpanel$ | async">
                  <div *ngIf="subpanel.data.parent === sidebar.data.id">
                    <div
                      class="panel-body"
                      style="
                        padding: 0px;
                        border: 0px !important;
                        background: transparent;
                      "
                    >
                      <ul class="nav nav-pills nav-stacked">
                        <li>
                          <a routerLink="{{ subpanel.data.routerLink }}">{{
                            subpanel.data.label
                          }}</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="slimScrollBar"
        style="
          background-color: rgb(0, 0, 0);
          width: 7px;
          position: absolute;
          top: 0px;
          opacity: 0.2;
          display: block;
          border-top-left-radius: 7px;
          border-top-right-radius: 7px;
          border-bottom-right-radius: 7px;
          border-bottom-left-radius: 7px;
          z-index: 99;
          left: 1px;
          height: 305.6842105263158px;
          background-position: initial initial;
          background-repeat: initial initial;
        "
      ></div>
      <div
        class="slimScrollRail"
        style="
          width: 7px;
          height: 100%;
          position: absolute;
          top: 0px;
          display: none;
          border-top-left-radius: 7px;
          border-top-right-radius: 7px;
          border-bottom-right-radius: 7px;
          border-bottom-left-radius: 7px;
          background-color: rgb(51, 51, 51);
          opacity: 0.2;
          z-index: 90;
          left: 1px;
          background-position: initial initial;
          background-repeat: initial initial;
        "
      ></div>
    </div>
  </div>
</div>
